





















import {Component, Vue} from "vue-property-decorator";
import ThingModelApi from "@/module/thing/ThingModelApi";
import {Container} from "typescript-ioc";
import productModule from "@/store/module/ProductModule";
import InstrTmpl from "@/module/instr/InstrTmpl";
import InstrTmplItem from "@/component/Thing/instr-tmpl-item.vue";
import RefreshButton from "@/component/Button/refresh-button.vue";

@Component({
  components: {
    InstrTmplItem,
    RefreshButton,
  }
})
export default class InstrTmplView extends Vue {

  private tmodelApi = Container.get(ThingModelApi)

  private instrTmpls: Array<InstrTmpl> = []

  private activeName = ""

  private get product() {
    return productModule.active
  }

  private created() {
    this.getInstrTmpls()
  }

  private async getInstrTmpls() {
    this.instrTmpls = await this.tmodelApi.instrTmpls(this.product.id)
  }

  private refresh() {
    this.getInstrTmpls()
  }
}
